import { render, staticRenderFns } from "./DataTo.vue?vue&type=template&id=490686fd"
import script from "./DataTo.vue?vue&type=script&lang=js"
export * from "./DataTo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports